import { MigrationSpec } from "../migration.models"

const extractContactInfoFlowNodeTemplates: MigrationSpec = {
  type: "SEED_EXTRACT_CONTACT_INFO_FLOW_NODE_TEMPLATES",
  collection: "FlowNodeTemplate",
  risk: "SAFE",
  title: {
    en: "FlowBot → Extract data node template",
    tr: "FlowBot → Veri ayıkla node şablonu"
  },
  description: {
    en:
      "Inserts the “Extract data” FlowBot node template (`type: extract_contact_info`) " +
      "when it is missing, keyed by `type`. Written with `$setOnInsert`, so a second run changes " +
      "nothing and an existing (possibly edited) template is never overwritten.",
    tr:
      "“Extract data” FlowBot node şablonunu (`type: extract_contact_info`) yoksa ekler; " +
      "anahtar `type`. `$setOnInsert` ile yazılır: ikinci çalıştırma hiçbir şey değiştirmez, " +
      "mevcut (düzenlenmiş olabilecek) şablonun üzerine asla yazılmaz."
  },
  expectedDocuments: {
    filter: { type: { $in: ["extract_contact_info"] } },
    count: 1
  },
  notes: [
    {
      en:
        "Until this runs, the Extract data node cannot be added to a flow in the builder. " +
        "Run the block template migration after it.",
      tr:
        "Bu çalışana kadar Veri ayıkla node'u flow builder'da bir akışa eklenemez. " +
        "Ardından blok şablonu migration'ını çalıştırın."
    }
  ]
}

export default extractContactInfoFlowNodeTemplates
